import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { Outlet } from 'react-router'

import { ErrorFallback } from '@/components/ErrorFallback'
import { RootLayout } from '@/shared/layouts/Default'
import { FeatureFlagProvider, QueryClientProvider } from '@/shared/providers'

const MyApp = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider>
        <ErrorBoundary fallback={<ErrorFallback />}>
          <FeatureFlagProvider>
            <RootLayout>
              <Outlet />
            </RootLayout>
          </FeatureFlagProvider>
        </ErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  )
}

export default MyApp
